import React from 'react';
import { currencyDisplay } from "../../_utils";
import LocalizedMessage from 'react-l10n';

function CartSummaryFooter(props) {
    const { detail, currencyFormat, currencyDisplayCode, locale } = props;
    const { TaxTotal, SubTotal } = detail;

    return (
        <div className='data-table__footer'>
            {/*<div className="data-table__tr" role="row">
                <div className="data-table__th">
                    <span className="data-table__info">
                        Tax
                    </span>
                </div>
                <div className="data-table__th tx-right">
                    <span className="data-table__info">{Numeral(TaxTotal).format('$ 0,0.00')}</span>
                </div>
            </div>*/}

            <div className='data-table__tr' role='row'>
                <div className='data-table__th'>
                    <span className='data-table__heading data-table__heading--big'>
                         <LocalizedMessage id={'SUBTOTAL'} />
                    </span>
                </div>
                <div className='data-table__th tx-right'>
                    <span className='data-table__heading data-table__heading--big'>
                        {currencyDisplay(SubTotal, currencyDisplayCode, currencyFormat, locale)}
                    </span>
                </div>
            </div>
        </div>
    );
}

// default props
CartSummaryFooter.defaultProps = {
    // message: '',
};
// validate props
CartSummaryFooter.propTypes = {
    // message: PropTypes.string,
};

export default CartSummaryFooter;
